module.exports = function trim( value ) {
  return value.replace( /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '' )
}



// WEBPACK FOOTER //
// ./node_modules/http-link-header/lib/trim.js